export const getHorizontalBarChartOptions = ({
  series,
  labels,
  eventHandler,
  color = '#1AB394',
}) => ({
  chart: {
    height: 350,
    type: 'bar',
    toolbar: {
      show: false,
    },
    events: {
      dataPointSelection(event, chartContext, config) {
        const { dataPointIndex } = config;
        if (typeof eventHandler === 'function') {
          eventHandler(labels[dataPointIndex]);
        }
      },
    },
  },
  plotOptions: {
    bar: {
      horizontal: true,
    },
  },
  dataLabels: {
    enabled: false,
  },
  tooltip: {
    y: {
      formatter(val) {
        return val;
      },
    },
  },
  series,
  colors: [color],
  xaxis: {
    categories: labels,
    axisBorder: {
      show: false,
    },
  },
  states: {
    hover: {
      filter: { type: 'none' },
    },
  },
  grid: {
    borderColor: 'blue',
    padding: {
      top: -20,
    },
  },
});
